import React, { ReactNode, useRef, useState } from 'react'
import './modals.sass'
import Button from '../Buttons/Button'
import Paragraph from '../Typography/Paragraph'

const AlertModal: React.FC<{
    modalTitle?: string | ReactNode
    modalMessage?: string | ReactNode
    // When it returns a promise, both buttons stay disabled until it settles (prevents double submissions)
    onConfirm: () => void | Promise<unknown>
    onClose: () => void
}> = ({ modalTitle, modalMessage, onConfirm, onClose }) => {
    const [isConfirming, setIsConfirming] = useState(false)
    const isConfirmingRef = useRef(false)

    const handleConfirm = async () => {
        if (isConfirmingRef.current) return
        isConfirmingRef.current = true
        setIsConfirming(true)
        try {
            await onConfirm()
        } finally {
            isConfirmingRef.current = false
            setIsConfirming(false)
        }
    }

    return (
        <div className="modal-wrapper">
            <div className="dark-cover" />

            <div className="modal-component">
                <div className="modal-component__header">
                    <span className="page-title">{modalTitle}</span>
                </div>
                <div className="modal-component__body">
                    <Paragraph>{modalMessage}</Paragraph>
                </div>
                <div className="modal-component__footer">
                    <Button buttonType="secondary" disabled={isConfirming} onClick={() => onClose()}>
                        Annulla
                    </Button>
                    <Button buttonType="primary" loading={isConfirming} onClick={() => void handleConfirm()}>
                        Conferma
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default AlertModal
